export default "__VITE_ASSET__24cb71a8__"